(function(){
     'use strict';

     angular
        .module('appback')
        .factory('ReglasdescuentoService', ReglasdescuentoService);

    ReglasdescuentoService.$inject = ['$http'];

    function ReglasdescuentoService($http){

        var service= {
           cambiarValor:cambiarValor,
        };

        return service;
 		function cambiarValor(id,valor,centro_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/regladescuento/cambiarvalor', { params : { centro_id:centro_id,id:id,valor:valor } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      
    }
})();